import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';
import PageTitle from '~/components/PageTitle';
import { S_Btn_Search, S_DateInput, S_Select, S_Title } from '~/components/SearchItem';
import ExportButton from '~/components/Button/ExportButton';
import SearchBar from '~/components/SearchBar';

const RenderTableTitle = (props) => {
  const { order, onSort } = props;
  const labelAry = useSelector(state => state.data.GisPlanReportDataV2?.labelAry || []);
  // const ary = [...labelAry.map(o => ({ name: [o.wind_name || '-', o.developer || '-', `${o.power || '-'} MW`], detail: [{ name: '預定' }, { name: '實際' }] })), { name: ['合計'], detail: [{ name: '預定' }, { name: '實際' }] }];
  const ary = [...labelAry.map(({ wind_name, developer, power }) => ({ name: [wind_name || '-', developer || '-', `${power || '-'} MW`], detail: [{ name: '預定' }, { name: '實際' }] })), { name: ['合計'], detail: [{ name: '預定' }, { name: '實際' }] }];

  const onChangeSort = () => {
    onSort();
  };

  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        <T_TitleCell
          rowSpan={2}
          style={{ fontSize: 20 }}
          color='#247691'
          text='項目'
          arrow={true}
          bol={order}
          onClick={() => onChangeSort()}
        />
        {ary.map((o, i) => (
          <TableCell
            key={i}
            style={{
              border: 'solid #DDDDDD',
              borderWidth: `0px ${(i !== (ary.length - 1)) ? 1 : 0}px 1px 1px`,
              whiteSpace: 'pre-line',
            }}
            colSpan={o.detail.length || 1}
            align='center'
          >
            <div>
              {(o.name || []).map((o2, i2) => <div key={i2}>{o2}</div>)}
            </div>
          </TableCell>
        ))}
      </TableRow>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => o.detail.map((o2, i2) => (
          <T_TitleCell
            key={`${i}-${i2}`}
            style={{
              border: 'solid #DDDDDD',
              borderWidth: `0px ${((i2 === (o.detail.length - 1)) && (i !== (ary.length - 1))) ? 1 : 0}px 1px ${(i2 === 0) ? 1 : 0}px`,
            }}
            text={o2.name}
            color='#247691'
          />
        )))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = (props) => {
  const { order } = props;
  
  const handleSort = (index, data, order) => {
    const newIndex = [...index];

    newIndex.sort((a, b) => {
      if (!order) {
        return b.localeCompare(a);
      } else {
        return a.localeCompare(b);
      }
    });

    const newData = newIndex.map((sortedDate) => {
      const originalIndex = index.indexOf(sortedDate);
      return data[originalIndex];
    });

    return {
      periods: newIndex,
      list: newData
    };
  };

  const cellStyle = { fontSize: 14, border: 'solid #DDDDDD' };
  const left_cellStyle = { ...cellStyle, borderWidth: '0px 0px 1px 0px' };
  const right_cellStyle = { ...cellStyle, borderWidth: '0px 1px 1px 0px' };
  const periodsX = useSelector((state) => state.data.GisPlanReportDataV2?.periods || []);
  const listX = useSelector((state) => state.data.GisPlanReportDataV2?.data || []);
  const PRData = handleSort(periodsX, listX, order);
  
  // true: 'desc', false: 'asc'

  return (
    <TableBody>
      {PRData.list.map((o, i) => (
        <T_TableRow key={i} backgroundColor={(i % 2 === 0) ? '#F1F1F1' : 'transparent'}>
          <TableCell align='center' style={{ color: '#247691', ...cellStyle, borderWidth: '0px 1px 1px 0px' }}>{PRData.periods[i]}</TableCell>
          {o.map((o2, i2) => <TableCell key={i2} align='center' style={i2 % 2 === 0 ? left_cellStyle : right_cellStyle}>{o2}</TableCell>)}
        </T_TableRow>
      ))}
    </TableBody>
  );
};

const RenderTable = () => {
  const [order, setOrder] = useState(true); // true: 'desc', false: 'asc'
  const list = useSelector(state => state.data.GisPlanReportDataV2?.data || []);
  const haveData = list.length;

  const handleSort = () => {
    setOrder(!order);
  };

  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle order={order} onSort={handleSort} />
        {haveData && <RenderTableBody order={order} />}
      </Table>
    </TableContainer>
  );
};

const App = props => {
  const [data, setData] = useState({ start_date: new Date(2023, 1 - 1), end_date: new Date(), stage: '' });
  const [sort, setSort] = useState('asc');
  const { start_date, end_date, stage } = data;
  const dispatch = useDispatch();
  const GisPlanReportDataV2 = useSelector(state => state.data.GisPlanReportDataV2 || {});
  const WindProjects = useSelector(state => state.data.SwitchProjectList || []);
  
  const [selectedWindProjects, setSelectedWindProjects] = useState([]);

  const haveData = GisPlanReportDataV2?.data?.length;

  const onClickSearch = () => {
    const windcontract_ids = selectedWindProjects.map(o => o.value);
    
    if (windcontract_ids.length > 0  && stage) {
      Actions_Wind.Gis.getGisPlanReportDataV2(dispatch, {
        start_date: moment(start_date).format('YYYY-M'),
        end_date: moment(end_date).format('YYYY-M'),
        stage,
      }, { windcontract_ids });
    }
  };

  const onExport = () => {
    if ((GisPlanReportDataV2.data?.length || 0) === 0) {
      alert('無匯出資料');
    } else {
      const excelAry = [];
      const ary1 = ['項目'];
      const ary2 = [''];
      (GisPlanReportDataV2.labelAry || []).forEach(o => {
        ary1.push(`${o.wind_name || '-'}\n${o.developer || '-'}\n${o.power || '-'} MW`);
        ary1.push('');
        ary2.push('預定');
        ary2.push('實際');
      });
      ary1.push('合計');
      ary1.push('');
      excelAry.push(ary1);
      excelAry.push(ary2);
      (GisPlanReportDataV2.data || []).forEach((o, i) => {
        const aryN = [GisPlanReportDataV2.periods?.[0] || ''];
        o.forEach(o2 => aryN.push(o2));
        excelAry.push(aryN);
      });

      excel.outputAryAry({
        data: excelAry,
        fileName: '工進規劃&實際報表_工進報表',
        wrapText: true,
      });
    }
  };

  useEffect(() => () => Actions_Wind.clearKey(dispatch, { key: 'GisPlanReportDataV2' }), []);
  
  const handleSelectWindFields = (e) => {
    const countMap = {};
    const resultArray = [];

    e.target.value.forEach(item => {
      const key = `${item.name}-${item.order_num}-${item.value}`;
      countMap[key] = (countMap[key] || 0) + 1;
    });

    e.target.value.forEach(item => {
      const key = `${item.name}-${item.order_num}-${item.value}`;
      if (countMap[key] === 1) {
        resultArray.push(item);
      }
    });

    setSelectedWindProjects(resultArray);
  };

  const isSelected = (id) => {
    return selectedWindProjects.some(o => o.value === id);
  }

  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}
    >
      <PageTitle text='工進規劃&實際報表' />

      <div style={{ marginTop: 24, display: 'flex' }}>
        <div style={{ marginLeft: 16 }}>
          <S_Title text='月份區間' />
          <S_DateInput value={start_date} onChange={t => setData({ ...data, start_date: t })} inputFormat='yyyy/MM' placeholder='年 / 月' />
        </div>
        <div style={{ marginLeft: 16, paddingTop: 24 }}>
          <S_DateInput value={end_date} onChange={t => setData({ ...data, end_date: t })} inputFormat='yyyy/MM' placeholder='年 / 月' />
        </div>
        <div style={{ marginLeft: 16 }}>
          <S_Title text='階段' />
          <S_Select list={['水下基礎基樁/安裝', '水下基礎套筒/安裝', '風力機/安裝'].map((o, i) => ({ name: o, value: (i + 1).toString() }))} value={stage} onChange={t => setData({ ...data, stage: t })} width={230} />
        </div>

        <div style={{ marginLeft: 16 }}>
          <FormControl variant='outlined' >
            <S_Title text='風場' />
            <Select
              labelId='ship-select-label'
              id='ship-select'
              style={{
                backgroundColor: 'white',
                width: 168,
                height: 44,
                fontSize: 16,
                letterSpacing: '0.15px',
                borderRadius: 8,
                paddingLeft: 12,
              }}
              multiple
              value={selectedWindProjects}
              onChange={handleSelectWindFields}
              renderValue={(selected) => {
                return (selected.map(o => o.name).join(', '));
              }}
              MenuProps={{ style: { left: -12 } }}
            >
              <MenuItem value="">請選擇</MenuItem>
              {WindProjects.map((wp) => (
                <MenuItem key={wp.value} value={wp}>
                  <Checkbox checked={isSelected(wp.value)} />
                  <ListItemText primary={wp.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
          <S_Btn_Search onClick={onClickSearch} />
        </div>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
      </div>

      <SearchBar style={{ marginTop: 16 }} text='工進報表' defaultOpen>
        <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
          <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
            { GisPlanReportDataV2.labelAry?.length && <RenderTable />}
          </div>
          {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        </div>
      </SearchBar>
    </div>
  );
};

export default App;

